import PropTypes from 'prop-types'
import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

import { Loader } from '~/ui/Loader'

const Container = styled.div`
  padding: ${theme('spacing.s')};
`

const FacilitiesListItemLoader = ({ className, label = '', variant = 'centered' }) => (
  <Container className={className}>
    <Loader label={label} variant={variant} />
  </Container>
)

FacilitiesListItemLoader.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.oneOf(['normal', 'inline', 'centered']),
}

export default FacilitiesListItemLoader
